// Module
var code = "<kendo-grid id=\"usersGrid\" k-scope-field=\"usersGrid\" flowingly-grid grid-init-done=\"$ctrl.gridInitDone\" grid-need-resize=\"$ctrl.gridNeedResize\" no-rows=\"$ctrl.noRows\" offset=\"300\" class=\"setup__grid runner-grid-default\" options=\"$ctrl.options\"> </kendo-grid> ";
// Exports
export default code;